'use client';
import styled from 'styled-components';

const ColumnBody = styled.div``;

export default ColumnBody;
